import * as React from "react";
const SvgModels = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M3.433 12.567a6.01 6.01 0 0 1-1.058-1.792A5.91 5.91 0 0 1 2 8.667C2 7 2.583 5.587 3.75 4.425 4.917 3.265 6.333 2.684 8 2.684c.111 0 .225.002.342.008.116.006.22.014.308.025L7.3 1.367l.7-.7 2.667 2.667L8 6l-.717-.716L8.817 3.75A6.201 6.201 0 0 0 8 3.683c-1.389 0-2.57.484-3.542 1.45C3.486 6.1 3 7.279 3 8.668c0 .567.094 1.133.283 1.7.19.567.478 1.061.867 1.483l-.717.717Zm3.934-.067c0-.233-.084-.472-.25-.716a17.747 17.747 0 0 0-.542-.75 8.196 8.196 0 0 1-.542-.809 1.733 1.733 0 0 1-.25-.891c0-.611.217-1.134.65-1.567.434-.433.956-.65 1.567-.65s1.133.217 1.567.65c.433.433.65.956.65 1.567 0 .31-.084.608-.25.891a8.196 8.196 0 0 1-.542.809c-.194.255-.375.505-.542.75-.166.244-.25.483-.25.716H7.367ZM7.333 14v-.833h1.334V14H7.333Zm5.234-1.433-.7-.7c.333-.4.605-.872.816-1.417A4.892 4.892 0 0 0 13 8.667c0-.733-.153-1.43-.458-2.092a4.894 4.894 0 0 0-1.375-1.741L11.9 4.1a6.142 6.142 0 0 1 1.533 2.009c.378.783.567 1.636.567 2.558a5.91 5.91 0 0 1-.375 2.108 6.011 6.011 0 0 1-1.058 1.792Z"
    />
  </svg>
);
export default SvgModels;
